import { type FC } from 'react';
import { Show, ShowFirstMatching } from '@components/Show';
import { Step } from '@features/create-entity-modal/types';
import { useFeatureFlags } from '@hooks/useFeatureFlags';
import type { Team } from '@root/@types/types';

import { Step1, Step2, Step2OpenSearch, Step3 } from '../components';
import type { StepProps } from '../types';

interface FormContentProps extends StepProps {
  currentStep: Step;
  isFetchingTeams: boolean;
  userTeams: Team[];
}

export const FormContent: FC<FormContentProps> = ({ currentStep, userTeams, ...stepProps }) => {
  const getFeatureFlag = useFeatureFlags();
  const isOpenSearchEnabled = getFeatureFlag('OpenSearch');
  return (
    <ShowFirstMatching>
      <Show when={currentStep === Step.GeneralEntityData}>
        <Step1 {...stepProps} currentStep={currentStep} userTeams={userTeams} />
      </Show>
      <Show when={currentStep === Step.BaseEntityData}>
        {isOpenSearchEnabled ? <Step2OpenSearch {...stepProps} /> : <Step2 {...stepProps} />}
      </Show>
      <Show when={currentStep === Step.BrandingInfo}>
        <Step3 {...stepProps} />
      </Show>
    </ShowFirstMatching>
  );
};
